module.exports = __webpack_public_path__ + "static/media/close-icon.aea44206.svg";